// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"73daa3b7","295":"03ef5356","354":"c558b284","696":"8727b07d","751":"1bb4e361","753":"03ef5356"}[chunkId] + ".chunk.css";
};